import React from 'react';
// import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import Logo from 'container/components/Logo';
import theme from 'container/theme';

function SmallScreenMenu(props) {
  const dispatch = useDispatch();

  const {
    showMainText,
    // setChat, setNewChat
  } = props;

  // const { selectedConversation } = useSelector(state => state.chat);

  // const handleDeleteConversation = () => {
  //   dispatch.chat.deleteConversation(selectedConversation.id);
  //   setChat([]);
  //   setNewChat([]);
  // };

  const handleOpenLeftMenu = () => {
    dispatch.utils.setOpenMobileChatMenu(true);
  };

  const handleOpenRightMenu = () => {
    dispatch.utils.setOpenMobileRightMenu(true);
  };

  return (
    <>
      <div
        className='left__small-header'
        style={{ borderBottom: `1px solid ${theme.colors.border}` }}
      >
        <div className='left__small-grid'>
          <div className='message-box' onClick={handleOpenLeftMenu}>
            <svg
              width='17'
              height='17'
              viewBox='0 0 17 17'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M5.86042 13.7119H5.48654C2.49551 13.7119 1 12.9641 1 9.22532V5.48654C1 2.49551 2.49551 1 5.48654 1H11.4686C14.4596 1 15.9551 2.49551 15.9551 5.48654V9.22532C15.9551 12.2164 14.4596 13.7119 11.4686 13.7119H11.0947C10.8629 13.7119 10.6386 13.824 10.4965 14.011L9.37488 15.5065C8.88136 16.1645 8.07378 16.1645 7.58026 15.5065L6.45862 14.011C6.33898 13.8465 6.06231 13.7119 5.86042 13.7119Z'
                stroke='white'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M11.4663 7.72998H11.473'
                stroke='white'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M8.47461 7.72998H8.48139'
                stroke='white'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M5.48242 7.72998H5.48919'
                stroke='white'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
          {/* LOGO */}
          {!showMainText && <Logo />}
          <div className='menu-box' onClick={handleOpenRightMenu}>
            <svg
              width='22'
              height='22'
              viewBox='0 0 22 22'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M18.3787 10.084H3.62034C3.1394 10.084 2.74951 10.4739 2.74951 10.9548V11.0465C2.74951 11.5274 3.1394 11.9173 3.62034 11.9173H18.3787C18.8596 11.9173 19.2495 11.5274 19.2495 11.0465V10.9548C19.2495 10.4739 18.8596 10.084 18.3787 10.084Z'
                fill='white'
              />
              <path
                d='M18.3787 14.667H3.62034C3.1394 14.667 2.74951 15.0569 2.74951 15.5378V15.6295C2.74951 16.1104 3.1394 16.5003 3.62034 16.5003H18.3787C18.8596 16.5003 19.2495 16.1104 19.2495 15.6295V15.5378C19.2495 15.0569 18.8596 14.667 18.3787 14.667Z'
                fill='white'
              />
              <path
                d='M18.3787 5.50049H3.62034C3.1394 5.50049 2.74951 5.89037 2.74951 6.37132V6.46299C2.74951 6.94394 3.1394 7.33382 3.62034 7.33382H18.3787C18.8596 7.33382 19.2495 6.94394 19.2495 6.46299V6.37132C19.2495 5.89037 18.8596 5.50049 18.3787 5.50049Z'
                fill='white'
              />
            </svg>
          </div>
        </div>
        {/* {selectedConversation && (
          <div className='chat__header-grid'>
            <p className='heading'>
              {selectedConversation.label?.includes('/imagine')
                ? selectedConversation.label?.replace('/imagine ', '')
                : selectedConversation.label}
            </p>
            <div className='delete-icon' onClick={handleDeleteConversation}>
              <svg
                width='17'
                height='17'
                viewBox='0 0 17 17'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M3.60693 4.07129V14.9999H13.2498V4.07129H3.60693Z'
                  stroke='white'
                  strokeWidth='1.5'
                  strokeLinejoin='round'
                />
                <path
                  d='M7.14258 7.28564V11.4642'
                  stroke='white'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M9.71387 7.28564V11.4642'
                  stroke='white'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M1.99951 4.07129H14.8567'
                  stroke='white'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M5.85693 4.07115L6.91411 2.14258H9.96386L10.9998 4.07115H5.85693Z'
                  stroke='white'
                  strokeWidth='1.5'
                  strokeLinejoin='round'
                />
              </svg>
            </div>
          </div>
        )} */}
      </div>
    </>
  );
}

export default SmallScreenMenu;
